import React, { useContext } from 'react';
import useStyles from '@front10/helpers/dist/UseStyles';
import { Context } from '@front10/helpers/dist/Context';
import { mapBoxProps, BaseBoxProps } from '../_commons/BaseBox';
import { StyledProps } from '@front10';

type ColSize = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12;

type ColSizeProps = {
  xs?: ColSize;
  sm?: ColSize;
  md?: ColSize;
  lg?: ColSize;
  xl?: ColSize;
};

export type ColProps = StyledProps<ColSizeProps & BaseBoxProps>;

function Col(props: ColProps) {
  const { xs, sm, md, lg, xl } = props;
  const { direction, theme } = useContext(Context);
  const [className, style] = useStyles(props, { direction, theme });

  let cls = '';
  if (xs) {
    cls = `fr-col-${xs}`;
  } else if (!sm && !md && !lg && !xl) {
    cls = 'fr-col';
  }
  if (sm) {
    cls += ` fr-col-sm-${sm}`;
  }
  if (md) {
    cls += ` fr-col-md-${md}`;
  }
  if (lg) {
    cls += ` fr-col-lg-${lg}`;
  }
  if (xl) {
    cls += ` fr-col-xl-${xl}`;
  }
  const newClassName = `${cls} ${className} `;

  return <div {...mapBoxProps(props)} className={newClassName} style={style} />;
}

Col.componentName = 'Col';

export default Col;
